/**
 * Resolve cargo(s) do colaborador: campo legado `cargo` + vínculos em `colaboradorCargos`.
 * Evita "Sem Cargo" quando o vínculo existe só na tabela colaborador_cargos.
 */
export function resolveCargosColaborador(col) {
  if (!col) {
    return { cargo_id: null, cargo_nome: 'Sem Cargo', cargo_ids: [] };
  }

  const seen = new Map();
  if (col.cargo?.nome) {
    seen.set(col.cargo.id, col.cargo.nome);
  }
  for (const cc of col.colaboradorCargos || []) {
    if (cc.ativo === false) continue;
    const c = cc.cargo;
    if (c?.id != null && c.nome && !seen.has(c.id)) {
      seen.set(c.id, c.nome);
    }
  }

  const pairs = [...seen.entries()].map(([id, nome]) => ({ id, nome }));
  if (pairs.length === 0) {
    return { cargo_id: null, cargo_nome: 'Sem Cargo', cargo_ids: [] };
  }

  const names = pairs.map((p) => p.nome);
  const ids = pairs.map((p) => p.id);
  return {
    cargo_id: ids[0],
    cargo_nome: pairs.length === 1 ? names[0] : names.join(', '),
    cargo_ids: ids,
  };
}

export function cargoNomeExibicao(col) {
  return resolveCargosColaborador(col).cargo_nome;
}
